import { apiPatch } from '@/services/api/apiClient';

export interface ChangePasswordData {
  currentPassword: string;
  newPassword: string;
}

export interface ChangePasswordResponse {
  success: boolean;
  message: string;
}

class ProfileService {
  private baseUrl = '/users/me';

  async changePassword(data: ChangePasswordData): Promise<ChangePasswordResponse> {
    return apiPatch<ChangePasswordResponse>(`${this.baseUrl}/change-password`, data);
  }
}

export const profileService = new ProfileService();
